(function ($) {
    'use strict';

    var Bowser = require("bowser");
    var $body = $('body');
    var isWhitelisted = $body.hasClass('is-homepage') || $body.hasClass('is-login');

    if (isWhitelisted) {
        return;
    }

    var browser = Bowser.getParser(window.navigator.userAgent);
    var isValidBrowser = browser.satisfies({
        chrome: '>=81',
        firefox: '>=81',
        edge: '>=81',
        safari: '>=12',
        samsung_internet: '>=11'
    });

    if (!isValidBrowser) {
        $('.browser-support').removeClass('u-is-hidden');
        $('.lease-app').addClass('u-is-hidden');
        $('.js-main-layout').addClass('u-is-hidden');
    }
})(require('jquery'));
